var _path, _g, _path2, _g2, _path3, _g3, _path4, _g4, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgZoomLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 62,
    height: 62,
    viewBox: "0 0 62 62",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_741_13734)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_741_13734)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_741_13734",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 63,
    height: 62
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.0428 61.885C48.1802 61.885 62.0729 48.0344 62.0729 30.9489C62.0729 13.8634 48.1802 0.0128174 31.0428 0.0128174C13.9053 0.0128174 0.0126953 13.8634 0.0126953 30.9489C0.0126953 48.0344 13.9053 61.885 31.0428 61.885Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_741_13734)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-1.51318 -1.50842H63.5859V63.3934H-1.51318V-1.50842Z",
    fill: "#E5E5E4"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_741_13734",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 62,
    height: 62
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31.043 61.2713C47.8406 61.2713 61.4576 47.6955 61.4576 30.9488C61.4576 14.2022 47.8406 0.626343 31.043 0.626343C14.2455 0.626343 0.628418 14.2022 0.628418 30.9488C0.628418 47.6955 14.2455 61.2713 31.043 61.2713Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_741_13734)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-0.897461 -0.894897H62.9835V62.7925H-0.897461V-0.894897Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_741_13734",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 3,
    y: 3,
    width: 57,
    height: 56
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M31.0428 58.8425C46.4948 58.8425 59.0212 46.3541 59.0212 30.9489C59.0212 15.5437 46.4948 3.0553 31.0428 3.0553C15.5908 3.0553 3.06445 15.5437 3.06445 30.9489C3.06445 46.3541 15.5908 58.8425 31.0428 58.8425Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_741_13734)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.53857 1.53406H60.547V60.3638H1.53857V1.53406Z",
    fill: "#4A8CFF"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask3_741_13734",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 12,
    y: 21,
    width: 37,
    height: 20
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M39.5568 27.3312L47.4681 21.5658C48.1606 21.0033 48.6863 21.1312 48.6863 22.1666V39.744C48.6863 40.9073 48.0323 40.7794 47.4681 40.3448L39.5568 34.5794V27.3312ZM12.7837 22.2178V35.3081C12.7965 38.2739 15.2199 40.6644 18.1947 40.6516H37.3641C37.9027 40.6516 38.3386 40.217 38.3515 39.68V26.577C38.3386 23.6112 35.9152 21.2207 32.9404 21.2334H13.771C13.2325 21.2462 12.7965 21.6681 12.7837 22.2178Z",
    fill: "white"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_741_13734)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.2705 19.725H50.212V42.16H11.2705V19.725Z",
    fill: "white"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_741_13734"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 62,
    height: 62,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_741_13734"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 63,
    height: 62,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZoomLogo);
export default __webpack_public_path__ + "static/media/zoomLogo.12a936a70cf11ea50275eb64a5888e50.svg";
export { ForwardRef as ReactComponent };